import {  db, } from './firebase';


export async function loadStudents(){
    const ret = await db.ref("students/").once("value");
    return ret.val()
}